/**
 * Contact title values
 */
export enum ContactTitleEnum {
	NONE = 'none',
	MR = 'mr',
	MRS = 'mrs',
	MS = 'ms',
	MISS = 'miss',
	DR = 'dr',
	PROF = 'prof',
	SIR = 'sir',
}
